// extracted by mini-css-extract-plugin
module.exports = {"TicketColumns":"TicketColumns_TicketColumns__2Fxjx","slide-in-right":"TicketColumns_slide-in-right__3yZZZ","slide-out-right":"TicketColumns_slide-out-right__2k_lL"};